import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

import { catchError, map, Observable, of, throwError } from 'rxjs';

import { ICountries, ITimeZone } from '@shared/interfaces/app.interface';
import { IUserProfile } from '@app/features/profile/interfaces/profile.interface';
import { IUser } from '@app/features/auth/interfaces/auth.interface';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  private baseUrl = environment.apiUrl;
  private readonly STORAGE_KEY = 'userDetail';

  userDetail = signal<any>(null)
  constructor(private http: HttpClient) { }
  getUserProfile(): Observable<{ success: boolean, data: IUserProfile }> {
    return this.http.get<{ success: boolean, data: IUserProfile }>(`${this.baseUrl}/user/details`).pipe(map((profile: { success: boolean, data: IUserProfile }) => profile))
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
  updateUserProfile(data: FormData): Observable<{ success: boolean, data: IUserProfile }> {
    return this.http.post<{ success: boolean, data: IUserProfile }>(`${this.baseUrl}/user/update/profile`, data).pipe(map((profile: { success: boolean, data: IUserProfile }) => profile))
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
  uploadProfileOrCoverPhoto(data: FormData): Observable<{ success: boolean, data: IUserProfile }> {
    return this.http.post<{ success: boolean, data: IUserProfile }>(`${this.baseUrl}/user/upload/photo`, data).pipe(map((photo: { success: boolean, data: IUserProfile }) => photo))
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
  deleteProfileOrCoverPhoto(data: { type: string }): Observable<{ success: boolean, data: IUserProfile }> {
    return this.http.request<{ success: boolean, data: IUserProfile }>('delete', `${this.baseUrl}/user/delete/photo`, {
      body: data,
    }).pipe(map((photo: { success: boolean, data: IUserProfile }) => photo))
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
  getLocation(): Observable<{ data: ICountries[] }> {
    return this.http.get<{ data: ICountries[] }>(`${this.baseUrl}/location/countries`).pipe(map((location: { data: ICountries[] }) => location))
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  getTimezones(locationId: number): Observable<{ data: ITimeZone[] }> {
    return this.http.get<{ data: ITimeZone[] }>(`${this.baseUrl}/location/timezones/${locationId}`).pipe(map((location: { data: ITimeZone[] }) => location))
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
  setUserDetail(profile: IUserProfile): void {
    this.userDetail.set(profile);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(profile));
  }

  searchUsers(query: string): Observable<{ success: boolean, data: IUser[] }> {
    const params = new HttpParams().set('search', query);
    return this.http.get<{ success: boolean, data: IUser[] }>(`${this.baseUrl}/user`, { params }).pipe(
      map((response: { success: boolean, data: IUser[] }) => {
        const users = response.data.map(this.transformUser);
        return users;
      }),
      catchError((error) => {
        return []
      })
    );
  }
  transformUser(user: IUser): { id: number, name: string, email: string  , avatar: string } {
    return {
      id: user.id,
      name: `${user.first_name} ${user.last_name}`,
      email: user.email,
      avatar: user.photo_url,
    };
  }

}